import { format } from "date-fns";
import { ja } from "date-fns/locale";

export const formatDate = (date: string | number | Date, template = "yyyy-MM-dd") =>
  format(new Date(date), template, {
    locale: ja,
  });
